





















































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { TbGoods,TbGoodsClass,TbSupplier } from '@/http';
import { calendarPanel } from "@/components"
import dayjs from "dayjs";
import { fmoney } from '@/common/money';
import { tailFun } from "@/common/util/tail";
import { Toast } from 'vant';
import selectProduct from "./selectProduct.vue"
import paginationPanel from "./paginationPanel.vue"
@Component({
    components: {
        calendarPanel,selectProduct,paginationPanel
    },
})
export default class searchDia extends Vue {
    public $refs: {
    };

    @Watch('searchValue.key')
    keyChange(){
        this.serachList();
    }
    fmoney=fmoney;
    tailFun =tailFun;
    show = false;

    userInfo = {}
    /**分类列表 */
    classList=[]

    /**查询项 */
    searchValue={
        supplierId:'',
        goodsClassId:"",
        start:'',
        end:'',
        timeType:null,
        key:'',
        sortType:1,
        sortValue:2,
        skip:0,
        count:10,
    }
    searchValue1 = {
        sjsjasc:false,
        sjsjdsc:true,
        xlasc:false,
        xldsc:false,
        kcasc:false,
        kcdsc:false,
        sjasc:false,
        sjdsc:false,
    }
    // 供应商下拉
    showGysPopover = false;
    option1 = [];
    // 单多选下拉
    showChoicePopover = false;
    option2 = [{label:'单选商品',value:1,},{label:'多选商品',value:2,}];
    choiceType = 1;

    /**列表加载相关 */
    refreshing= false;
    loading = false;
    finished = false;
    list=[];
    total=0;
    currentPage=1

    /**列表每页条数：单选10条；多选一律100条 */
    singlePageSize = 10;
    multiPageSize = 100;
    /**多选全选/添加上限（商品种类，对应 dblist 最多100条） */
    maxSelectCount = 100;
    /**多选分页组件重置标记 */
    rePagin = false;
    /**多选跨页勾选缓存（未加入 dblist 前翻页仍保留），key 为商品 id */
    pendingCheckedMap:any = {};

    /**时间控件 */
    pickerShow = false;
    startDate="";
    endDate="";
    minDate = new Date(new Date().getFullYear() - 1, 0, 1);
    maxDate = new Date(new Date().getFullYear() , new Date().getMonth(), new Date().getDate());

    timeActive=null;
    //页面下的选择调拨数据
    dblist = [];

    allchecked = false;
    dxchecklist = [];

    created() {
    }
    mounted() {
        this.userInfo = JSON.parse(localStorage.getItem('padUserinfo'));
    }
    /**获取供应商名称 */
    get getSuppliername(){
        let str = ""
        if(this.searchValue.supplierId){
            str = this.option1.findIndex(v=>v.id==this.searchValue.supplierId)>-1?this.option1.find(v=>v.id==this.searchValue.supplierId).name:'';
        }
        return str;
    }
    /**获取是否单双选名称 */
    get getChoicename(){
        let str = ""
        str = this.option2.findIndex(v=>v.value==this.choiceType)>-1?this.option2.find(v=>v.value==this.choiceType).label:'';
        return str;
    }
    /**当前列表请求条数：单选10；多选100 */
    getPageCount(){
        return this.choiceType==2?this.multiPageSize:this.singlePageSize;
    }
    /**清空多选跨页勾选缓存 */
    clearPendingChecked(){
        this.pendingCheckedMap = {};
    }
    /**把当前页勾选状态同步进跨页缓存 */
    syncPendingFromList(){
        if(this.choiceType!=2) return;
        this.list.forEach(v=>{
            if(v.ischecked){
                this.$set(this.pendingCheckedMap, v.id, Object.assign({}, v, {ischecked:true}));
            }else if(this.pendingCheckedMap[v.id]){
                this.$delete(this.pendingCheckedMap, v.id);
            }
        });
    }
    /**用跨页缓存恢复当前页勾选 */
    applyPendingToList(){
        if(this.choiceType!=2) return;
        this.list = this.list.map(v=>{
            return Object.assign({}, v, {ischecked:!!this.pendingCheckedMap[v.id]});
        });
        this.syncAllChecked();
    }
    /**写入/移除跨页勾选 */
    setPendingChecked(item, checked){
        if(!item || !item.id) return;
        if(checked){
            this.$set(this.pendingCheckedMap, item.id, Object.assign({}, item, {ischecked:true}));
        }else if(this.pendingCheckedMap[item.id]){
            this.$delete(this.pendingCheckedMap, item.id);
        }
    }
    /**重置多选分页组件到第1页 */
    resetPagination(){
        this.rePagin = true;
        this.$nextTick(()=>{
            this.rePagin = false;
        })
    }
    /**重新加载列表：单选走触底加载，多选按页替换 */
    async onRefresh(){
        this.allchecked = false;
        this.clearPendingChecked();
        this.list = [];
        this.searchValue.skip = 0;
        this.searchValue.count = this.getPageCount();
        this.total = 0;
        this.currentPage = 1;
        this.resetPagination();
        if(this.choiceType==2){
            // 多选：按页替换，不使用触底加载
            this.finished = true;
            this.loading = false;
            await this.getPageList();
            this.refreshing = false;
        }else{
            this.finished = false;
            this.loading = true;
            this.loadMore();
        }
    }
    /**多选分页请求：按 skip/count 替换整页数据 */
    async getPageList(){
        this.loading = true;
        try{
            let res = await TbGoods.GetGoodsList(Object.assign({},this.searchValue,{
                shopId:this.userInfo['shopId']
            }));
            this.list = (res.items||[]).filter(v=>v.isShelves).map(v=>{
                return {
                    ...v,
                    ischecked:false
                }
            });
            this.total = res.totalCount;
            this.applyPendingToList();
        }finally{
            this.loading = false;
        }
    }
    async serachList(){
        await this.getList();
    }
    /**触底加载：仅单选；多选改由底部页码切换 */
    async loadMore(){
        if(this.choiceType==2) return;
        setTimeout(async() => {
            if (this.refreshing) {
                this.list = [];
                this.refreshing = false;
            }
            let s = this.searchValue.count;
            let res = await TbGoods.GetGoodsList(Object.assign({},this.searchValue,{
                shopId:this.userInfo['shopId']
            }));
            this.list = this.searchValue.skip==0? res.items.filter(v=>v.isShelves).map(v=>{
                return {
                    ...v,
                    ischecked:false
                }
            }):this.list.concat(res.items.filter(v=>v.isShelves).map(v=>{
                return {
                    ...v,
                    ischecked:false
                }
            }));
            this.total  = res.totalCount;
            this.currentPage++;
            this.searchValue.skip = (this.currentPage - 1) * s;
            this.loading = false;
            if (this.list.length >= this.total) {
                this.finished = true;
            }
        }, 1000);
    }
    /**多选分页切换：第1页 skip=0，第2页 skip=100，以此类推；翻页保留勾选 */
    async onPaginationChange(opt){
        if(this.choiceType!=2) return;
        this.syncPendingFromList();
        this.allchecked = false;
        this.currentPage = opt.currentPage;
        this.searchValue.skip = opt.skip;
        this.searchValue.count = opt.count||this.multiPageSize;
        this.list = [];
        await this.getPageList();
    }
    async showFun(val){
        Toast.loading();
        this.dblist = val;
        this.clearPendingChecked();
        await this.getClassList();
        await this.getSupplierList();
        await this.getList();
        this.show = true;
        Toast.clear();
    }
    /**获取商品列表 */
    async getList(){
        await this.onRefresh();
    }
    /**获取供应商下拉 */
    async getSupplierList(){
        let res = await TbSupplier.GetTbSupplierDropList();
        this.option1 = res;
        console.log('this.option1',this.option1);
    }
    /**选择供应商id查询 */
    async changeSuppilerXL(item){
        this.searchValue.supplierId = item.id;
        this.showGysPopover = false;
        await this.getList();
    }
    /**选择全部供应商 */
    async chooseAllSupplier(){
        this.searchValue.supplierId="";
        this.showGysPopover = false;
        await this.getList();
    }
    /**选择单多选 */
    async changeChoiceXL(item){
        this.choiceType = item.value;
        this.allchecked = false;
        this.showChoicePopover = false;
        this.clearPendingChecked();
        // 切换单/多选后按对应每页条数重新加载
        await this.onRefresh();
    }
    //顺序切换
    async changeSort(type){
        console.log('type',type);
        switch (type) {
            case 'sjsj':
                if (this.searchValue1.sjsjdsc) {
                    this.searchValue1.kcasc = false;
                    this.searchValue1.kcdsc = false;
                    this.searchValue1.xlasc = false;
                    this.searchValue1.xldsc = false;
                    this.searchValue1.sjasc = false;
                    this.searchValue1.sjdsc = false;
                    this.searchValue1.sjsjdsc = false;
                    this.searchValue1.sjsjasc = true;
                    this.searchValue.sortType = 1;
                    this.searchValue.sortValue = 1;
                    await this.getList();
                } else {
                    this.searchValue1.kcasc = false;
                    this.searchValue1.kcdsc = false;
                    this.searchValue1.xlasc = false;
                    this.searchValue1.xldsc = false;
                    this.searchValue1.sjsjdsc = true;
                    this.searchValue1.sjsjasc = false;
                    this.searchValue1.sjasc = false;
                    this.searchValue1.sjdsc = false;
                    this.searchValue.sortType = 1;
                    this.searchValue.sortValue = 2;
                    await this.getList();
                }
                break;
            case 'xl':
                if (this.searchValue1.xldsc) {
                    this.searchValue1.kcasc = false;
                    this.searchValue1.kcdsc = false;
                    this.searchValue1.xlasc = true;
                    this.searchValue1.xldsc = false;
                    this.searchValue1.sjsjdsc = false;
                    this.searchValue1.sjsjasc = false;
                    this.searchValue1.sjasc = false;
                    this.searchValue1.sjdsc = false;
                    this.searchValue.sortType = 2;
                    this.searchValue.sortValue = 1;
                    await this.getList();
                } else {
                    this.searchValue1.kcasc = false;
                    this.searchValue1.kcdsc = false;
                    this.searchValue1.xlasc = false;
                    this.searchValue1.xldsc = true;
                    this.searchValue1.sjsjdsc = false;
                    this.searchValue1.sjsjasc = false;
                    this.searchValue1.sjasc = false;
                    this.searchValue1.sjdsc = false;
                    this.searchValue.sortType = 2;
                    this.searchValue.sortValue = 2;
                    await this.getList();
                }
                break;
            case 'kc':
                if (this.searchValue1.kcdsc) {
                    this.searchValue1.kcasc = true;
                    this.searchValue1.kcdsc = false;
                    this.searchValue1.xlasc = false;
                    this.searchValue1.xldsc = false;
                    this.searchValue1.sjsjdsc = false;
                    this.searchValue1.sjsjasc = false;
                    this.searchValue1.sjasc = false;
                    this.searchValue1.sjdsc = false;
                    this.searchValue.sortType = 3;
                    this.searchValue.sortValue = 1;
                    await this.getList();
                } else {
                    this.searchValue1.kcasc = false;
                    this.searchValue1.kcdsc = true;
                    this.searchValue1.xlasc = false;
                    this.searchValue1.xldsc = false;
                    this.searchValue1.sjsjdsc = false;
                    this.searchValue1.sjsjasc = false;
                    this.searchValue1.sjasc = false;
                    this.searchValue1.sjdsc = false;
                    this.searchValue.sortType = 3;
                    this.searchValue.sortValue = 2;
                    await this.getList();
                }
                break;
            case 'sj':
                if (this.searchValue1.sjdsc) {
                    this.searchValue1.kcasc = false;
                    this.searchValue1.kcdsc = false;
                    this.searchValue1.xlasc = false;
                    this.searchValue1.xldsc = false;
                    this.searchValue1.sjsjdsc = false;
                    this.searchValue1.sjsjasc = false;
                    this.searchValue1.sjasc = true;
                    this.searchValue1.sjdsc = false;
                    this.searchValue.sortType = 4;
                    this.searchValue.sortValue = 1;
                    await this.getList();
                } else {
                    this.searchValue1.kcasc = false;
                    this.searchValue1.kcdsc = false;
                    this.searchValue1.xlasc = false;
                    this.searchValue1.xldsc = false;
                    this.searchValue1.sjsjdsc = false;
                    this.searchValue1.sjsjasc = false;
                    this.searchValue1.sjasc = false;
                    this.searchValue1.sjdsc = true;
                    this.searchValue.sortType = 4;
                    this.searchValue.sortValue = 2;
                    await this.getList();
                }
                break;
            default:
                break;
        }
    }
    openselDate() {
        this.pickerShow = true;
    }
    /**确定选择时间 */
    async onselConfirm(date){
        const [start, end] = date;
        this.startDate = dayjs(start).format("YYYY-MM-DD");
        this.endDate = dayjs(end).format("YYYY-MM-DD");
        this.searchValue.start = dayjs(start).format("YYYY-MM-DD") + " " + "00:00:00";
        this.searchValue.end = dayjs(end).format("YYYY-MM-DD") + " " + "23:59:59";
        this.pickerShow = false;
        this.searchValue.timeType = null;
        await this.getList();
    }
    closeTime(){
        this.pickerShow = false;
    }
    //选择timetype
    async chooseTime(type){
        this.startDate = '';
        this.endDate = '';
        this.searchValue.start = '';
        this.searchValue.end = '';
        this.searchValue.timeType = type;
        await this.getList();
    }
    /**获取分类列表 */
    async getClassList(){
        let res = await TbGoodsClass.GetAllGoodsClassList({
            needGoodsCount:true
        }) 
        this.classList = res.map(v=>{
            return{
                ...v,
                isShowChild:false
            }
        });
    }
    /**选择全部分类 */
    async chooseAllClass(){
        this.classList = this.classList.map(v=>{
            return {
                ...v,
                isShowChild:false
            }
        })
        this.searchValue.goodsClassId="";
        await this.getList();
    }
    /**选择一级分类 */
    async chooseClass(item,index){
        /**只有一级 */
        if(item.items.length==0){
            this.classList = this.classList.map(v=>{
                return {
                    ...v,
                    isShowChild:false
                }
            })
            this.searchValue.goodsClassId = item.id;
            await this.getList();
        }else{
            let checked = !item.isShowChild;
            this.classList = this.classList.map(v=>{
                return {
                    ...v,
                    isShowChild:false
                }
            })
            this.$set(this.classList[index],'isShowChild',checked);
            this.searchValue.goodsClassId = item.id;
            await this.getList();
        }
    }
    /**选择二级分类 */
    async chooseClassChid(item,index,index2){
        this.searchValue.goodsClassId = item.id;
        await this.getList();
    }
    /**获取分类选中状态 */
    getActiveStatus(item){
        let str = '';
        if(item.items.length==0){
            if(this.searchValue.goodsClassId==item.id){
                str = "isActive"
            }
        }else{
            if(item.items.findIndex(v=>v.id==this.searchValue.goodsClassId)>-1||this.searchValue.goodsClassId==item.id){
                str = "isActive2"
            }
        }
        return str;
    }
    closeFun(){
        this.searchValue={
            supplierId:'',
            goodsClassId:"",
            start:'',
            end:'',
            timeType:null,
            key:'',
            sortType:1,
            sortValue:2,
            skip:0,
            count:this.singlePageSize,
        }
        this.choiceType = 1;
        this.allchecked = false;
        this.clearPendingChecked();
        this.startDate ="";
        this.endDate ="";
        this.searchValue1 = {
            sjsjasc:false,
            sjsjdsc:true,
            xlasc:false,
            xldsc:false,
            kcasc:false,
            kcdsc:false,
            sjasc:false,
            sjdsc:false,
        }
        this.$nextTick(()=>{
            this.show = false;
        })
    }
    //清空搜索项
    async resetPart(){
        this.searchValue.supplierId = '';
        this.searchValue.start = '';
        this.searchValue.end = '';
        this.startDate = '';
        this.endDate = '';
        this.searchValue.key = '';
        this.searchValue.timeType = null;
        await this.getList();
    }
    //打开选择货品弹窗 / 多选勾选
    showDetail(item,index){
        console.log('id',item);
        if(this.choiceType==1) {
            // 单选：新商品已达上限则不允许再打开
            if(!this.getDblistGoodsIdSet().has(item.id)&&this.getDblistGoodsIdSet().size>=this.maxSelectCount){
                Toast(`最多只能选择${this.maxSelectCount}条商品`);
                return;
            }
            this.$refs['selPro'].showFun(item.id);
        }else{
            // 无规格商品无法加入调拨单，不允许勾选
            if(!item.goodsItems||item.goodsItems.length==0){
                Toast('该商品无规格，无法添加');
                return;
            }
            // 取消勾选不限制；再次选中时商品数（种类）不能超过上限
            if(!item.ischecked&&this.isGoodsSelectOverflow(item.id)){
                Toast(`最多只能选择${this.maxSelectCount}条商品`);
                return;
            }
            let nextChecked = !item.ischecked;
            this.$set(this.list[index], "ischecked", nextChecked);
            this.setPendingChecked(this.list[index], nextChecked);
            this.syncAllChecked();
        }
    }
    /**dblist 中已有商品种类（goodsId；历史脏数据用货号兜底） */
    getDblistGoodsIdSet(){
        let ids = this.dblist.map(v=>v.goodsId||v.goodsID||v.articleNo).filter(Boolean);
        return new Set(ids);
    }
    /**跨页勾选中尚未在 dblist 的新商品 */
    getPendingNewList(){
        let dblistIds = this.getDblistGoodsIdSet();
        return Object.keys(this.pendingCheckedMap).map(k=>this.pendingCheckedMap[k]).filter(v=>{
            return !dblistIds.has(v.id)&&!dblistIds.has(v.articleNo);
        });
    }
    /**
     * 商品数量展示：已在调拨单中的商品 + 跨页新勾选（含未加入 dblist）
     * 与上限口径一致，已在 dblist 的勾选不重复计数
     */
    getTotalSelectedGoodsCount(){
        return this.getDblistGoodsIdSet().size + this.getPendingNewList().length;
    }
    /**
     * 再选中该商品是否会超出商品上限
     * 已在 dblist / 已在跨页勾选中的可重复操作；新商品需计入已有商品数
     */
    isGoodsSelectOverflow(goodsId){
        let dblistIds = this.getDblistGoodsIdSet();
        let item = this.list.find(v=>v.id==goodsId);
        if(dblistIds.has(goodsId)||(item&&dblistIds.has(item.articleNo))) return false;
        if(this.pendingCheckedMap[goodsId]) return false;
        return this.getTotalSelectedGoodsCount() >= this.maxSelectCount;
    }
    /**同步全选勾选框状态 */
    syncAllChecked(){
        if(this.list.length==0){
            this.allchecked = false;
            return;
        }
        let dblistIds = this.getDblistGoodsIdSet();
        let remain = this.getRemainSelectCount();
        let isInDblist = (v)=>dblistIds.has(v.id)||dblistIds.has(v.articleNo);
        // 可勾选：有规格的商品里，已在调拨单中的 + 剩余可新增名额
        let canCheckList = this.list.filter(v=>v.goodsItems&&v.goodsItems.length>0);
        let canCheckCount = canCheckList.filter(isInDblist).length + remain;
        canCheckCount = Math.min(canCheckCount, canCheckList.length);
        this.allchecked = this.list.filter(v=>v.ischecked).length >= canCheckCount && canCheckCount > 0;
    }
    /**还能再新选多少个商品（排除当前页已在 pending 中的，避免重复扣减） */
    getRemainSelectCount(){
        let dblistIds = this.getDblistGoodsIdSet();
        let pageIds = new Set(this.list.map(v=>v.id));
        let otherPendingNew = Object.keys(this.pendingCheckedMap).map(k=>this.pendingCheckedMap[k]).filter(v=>{
            if(pageIds.has(v.id)) return false;
            return !dblistIds.has(v.id)&&!dblistIds.has(v.articleNo);
        }).length;
        return Math.max(0, this.maxSelectCount - dblistIds.size - otherPendingNew);
    }
    getShopnum(id){
        let num = 0;
        let arr = id?this.dblist.filter((v) => (v.goodsId||v.goodsID) == id).map((v) => v.num):[];
        if (arr.length > 0) {
            num = arr.reduce((n, m) => Number((Number(n) + Number(m)).toFixed(0)));
        }
        return Number(num);
    }
    //选择货品完成（单选）
    chooseFun(val){
        console.log('vallll',val);
        val.forEach((v)=>{
            if(this.dblist.findIndex(z=>z.goodsItemsId == v.goodsItemsId)>-1){
                //找到
                let index = this.dblist.findIndex(z=>z.goodsItemsId == v.goodsItemsId);
                this.$set(this.dblist[index],'num',Number(this.dblist[index].num)+Number(v.num));
            }else{
                this.dblist.push(v);
            }  
        })
    }
    //改变全选：按当前页商品勾选，并写入跨页缓存；最多勾选上限个商品
    changeCheck(val){
        let checked = !!val;
        this.allchecked = checked;
        if(!checked){
            this.list = this.list.map(v=>{
                this.setPendingChecked(v,false);
                return {
                    ...v,
                    ischecked:false
                }
            })
            return;
        }
        // 已在 dblist 的商品可全勾；新商品最多补满到上限；无规格不可勾
        let dblistIds = this.getDblistGoodsIdSet();
        let remain = this.getRemainSelectCount();
        let isInDblist = (v)=>dblistIds.has(v.id)||dblistIds.has(v.articleNo);
        let newChecked = 0;
        let overflow = false;
        this.list = this.list.map(v=>{
            if(!v.goodsItems||v.goodsItems.length==0){
                this.setPendingChecked(v,false);
                return Object.assign({}, v, {ischecked:false});
            }
            if(isInDblist(v)){
                let row = Object.assign({}, v, {ischecked:true});
                this.setPendingChecked(row,true);
                return row;
            }
            if(newChecked < remain){
                newChecked++;
                let row = Object.assign({}, v, {ischecked:true});
                this.setPendingChecked(row,true);
                return row;
            }
            overflow = true;
            this.setPendingChecked(v,false);
            return Object.assign({}, v, {ischecked:false});
        })
        if(overflow){
            Toast(`最多只能选择${this.maxSelectCount}条商品`);
        }
    }
    //添加商品（跨页勾选一并提交）
    addSearchitem(){
        this.syncPendingFromList();
        let selected = Object.keys(this.pendingCheckedMap).map(k=>this.pendingCheckedMap[k])
            .filter(v=>v.goodsItems&&v.goodsItems.length>0);
        if(selected.length==0){
            Toast('请先选择商品');
            return;
        }
        let arr = []
        arr = selected.map(v=>{
            return {
                goodsItems:v.goodsItems.map(j=>{
                    return{
                        ...j,
                        // 规格可能无 goodsId，用列表商品 id 兜底，保证种类计数=勾选数
                        goodsId:j.goodsId||v.id,
                        goodsItemsId:j.id,
                        articleNo:v.articleNo,
                        name:v.name,
                        price:v.sellingPrice,
                        goodsImgUrl:v.goodsImgUrl,
                        num:1
                    }
                })
                
            }
        })
        console.log('arrrr',arr)
        this.$emit('chooseFun1',arr);
        this.closeFun();
    }
    //计算数量（含跨页勾选）
    getNum(){
        let num = 0;
        let num1 = 0;
        let num2 = 0
        let arr = Object.keys(this.pendingCheckedMap).map(k=>this.pendingCheckedMap[k]).map((v) => (v.goodsItems||[]).length);
        let arr2 = this.dblist.filter((v) => Number(v.num) > 0).map((v) => v.num);
        if (arr.length > 0) {
            num1 = arr.reduce((n, m) => Number((Number(n) + Number(m)).toFixed(0)));
        }
        if (arr2.length > 0) {
            num2 = arr2.reduce((n, m) => Number((Number(n) + Number(m)).toFixed(0)));
        }
        num = Number(num1+num2);
        return Number(num);
    }   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/allot/components/searchDia.vue